/**
 * Hook that sends a GA4 page_view event whenever the route changes.
 *
 * Must be rendered inside a component that is a descendant of <BrowserRouter>.
 */

import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackPageView } from "@/lib/analytics"

/**
 * Listens for route changes and fires a GA4 page_view event for each
 * navigation. This ensures SPA route transitions are tracked, since
 * single-page apps don't trigger full page loads that GA would normally detect.
 */
export function usePageTracking(): void {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])
}
